export async function generateHeaders(): Promise<Record<string, string>> {
    const encoder = new TextEncoder();
    const timestamp = Date.now().toString();
    const secretKey = process.env.REACT_APP_ENCRYPTION_KEY;

    if (!secretKey) {
        throw new Error("Missing REACT_APP_ENCRYPTION_KEY in environment");
    }

    // Only sign the timestamp (matches backend)
    const dataToSign = timestamp;


    async function sha256(message: any): Promise<any> {
        const hash = await crypto.subtle.digest(
            'SHA-256',
            new TextEncoder().encode(message)
        );
        return Array.from(new Uint8Array(hash))
            .map(b => b.toString(16).padStart(2, '0'))
            .join('');
    }

    async function hmacSha256(key: string, message: string): Promise<string> {
        const blockSize = 64;
        let keyBytes = new TextEncoder().encode(key);

        if (keyBytes.length > blockSize) {
            keyBytes = new Uint8Array(await sha256(key));
        }

        const paddedKey = new Uint8Array(blockSize);
        paddedKey.set(keyBytes);

        const oKeyPad = paddedKey.map(b => b ^ 0x5c);
        const iKeyPad = paddedKey.map(b => b ^ 0x36);

        const innerHash = await sha256(new TextDecoder().decode(iKeyPad) + message);
        return sha256(new TextDecoder().decode(oKeyPad) + innerHash);
    }

    const signatureHex = await hmacSha256(secretKey, dataToSign);
    console.log(signatureHex);

    return {
        "Content-Type": "application/json",
        "x-timestamp": timestamp,
        "x-signature": signatureHex,
    };
}